import React from "react";
import { 
    TableCell, 
    TextField, 
    FormControl, 
    InputLabel, 
    Select, 
    OutlinedInput, 
    MenuItem, 
    Button, 
    Table, 
    TableHead, 
    TableBody, 
    TableRow, 
    FormControlLabel,
    Checkbox
} from '@mui/material';
import MemberAgeGroup from '../../../models/MemberAgeGroups'
import MasterData from './MasterData'
import { bool } from 'prop-types';


const AgeGroups = (props: any) => {

    const TableColumns: string[] = ['ID', 'Bezeichnung', 'Alter von', 'bis', 'Beschreibung', 'Aktiv','Jahrgang', 'Aktionen']

        let columns: JSX.Element[] = TableColumns.map((x, index) => {

            return <TableCell key={index}>{x}</TableCell>
        })

        return (
            <>
                <h2 className='mt-3 title'>Stammdaten - Altersklassen</h2>

                <div className='card'>
                    <div className='card-header'>
                        <h5>Filters</h5>
                    </div>
                    <div className='card-body'>
                        <div className='row'>
                            <div className='col-sm-5'>
                                <TextField 
                                    label='Bezeichnung:'
                                    name='name'
                                    value={props.filter.name}
                                    onChange={(e:any) => props.handleFilterChange(e)}
                                    fullWidth></TextField>
                            </div>
                            <div className='col-sm-5 offset-sm-1'>
                            <TextField 
                                    label='Beschreibung:'
                                    name='description'
                                    value={props.filter.description}
                                    onChange={(e:any) => props.handleFilterChange(e)}
                                    fullWidth></TextField>
                            </div>
                        </div>
                        <div className='float-right mt-4'>
                            <Button 
                                variant='contained' 
                                color='primary' 
                                className='btnBlue' 
                                onClick={() => props.handleSearch()}
                                >Suchen
                            </Button>
                            <Button 
                                className='ml-2 btnBlue' 
                                color='primary' 
                                variant='contained'
                                onClick={() => props.clearFilters()}
                                >Zurücksetzen</Button>
                        </div>
                    </div>
                </div>

                <div className='row mt-3 overflowTable'>
                    <Table className="objects-table table">
                        <TableHead>
                            <TableRow>
                                {columns}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {props.rows}
                        </TableBody>
                    </Table>
                </div>
                {
                    !props.addNew &&
                    <Button 
                        className='mt-3 float-right btnBlue' 
                        color='primary' 
                        variant="contained"
                        onClick={() => {
                            props.changeMode('create')
                            props.showAddNew()
                        }}
                        >Hinzufügen</Button>
                }
                {
                    props.addNew &&
                    <div className='row'>
                        <div className='col-sm-12'>
                            <h4>Altersklasse bearbeiten:</h4>
                        </div>
                        <div className='col-sm-12'>
                            <div className='col-sm-6 d-inline-block'>
                                <TextField 
                                    value={props.newObject.groupName} 
                                    name='groupName' 
                                    label='Bezeichnung' 
                                    onChange={(e:any) => props.handleChangeNewObject(e)}
                                    fullWidth/>
                            </div>
                            <div className='col-sm-6 d-inline-block'>
                                <TextField
                                    value={props.newObject.groupDescription} 
                                    name='groupDescription' 
                                    label='Beschreibung'
                                    onChange={(e:any) => props.handleChangeNewObject(e)} 
                                    fullWidth/>
                            </div>
                            <div className='col-sm-6 d-inline-block'>
                                <TextField 
                                    value={props.newObject.groupAgeFrom} 
                                    name='groupAgeFrom' 
                                    label='Alter von' 
                                    onChange={(e:any) => props.handleChangeNewObject(e)}
                                    fullWidth/>
                            </div>
                            <div className='col-sm-6 d-inline-block'>
                                <TextField 
                                    value={props.newObject.groupAgeTo} 
                                    name='groupAgeTo' 
                                    type='numeric' 
                                    label='Alter bis'
                                    onChange={(e:any) => props.handleChangeNewObject(e)} 
                                    fullWidth/>
                            </div>
                            <div className='col-sm-6 mt-3 d-inline-block'>
                            <FormControl variant="outlined" fullWidth>
                                    <InputLabel htmlFor="outlined-aktiv">
                                        Activ
                                    </InputLabel>
                                    <Select
                                        input={
                                            <OutlinedInput id='outlined-aktiv' fullWidth/>
                                        }
                                        name='activ'
                                        onChange={(e:any) => props.handleChangeNewObject(e)}
                                        value={props.newObject.activ.toString()}
                                        fullWidth
                                    >
                                        <MenuItem value={'true'}>Ja</MenuItem>
                                        <MenuItem value={'false'}>Nein</MenuItem>
                                    </Select>
                                </FormControl>
                            </div>
                            <div className='col-sm-6 mt-3 d-inline-block'>
                                <FormControlLabel control={
                                    <Checkbox
                                        style={{ color: 'rgb(0, 155, 229)' }}
                                        name='isJahrgang'
                                        checked={props.newObject.isJahrgang === "true" || props.newObject.isJahrgang === true }
                                        onChange={(e:any) => {
                                            e.target.value = e.target.checked.toString()
                                            props.handleChangeNewObject(e)
                                        }}
                                    />
                                } label="Jahrgang" />
                            </div>
                        </div>
                        <div className='col-sm-4 offset-sm-8'>
                        <Button 
                            className='mt-3 float-right btnBlue' 
                            color='primary' 
                            variant="contained" 
                            onClick={() => props.submitNewObject()}>Speichern</Button>
                        <Button 
                            className='mt-3 mr-2 float-right btnBlue' 
                            color='primary'
                            variant="contained"
                            onClick={() => props.hideAddNew()}>Abbrechen</Button>
                        </div>
                    </div>
                }
            </>
        )
}
export default MasterData<MemberAgeGroup, keyof MemberAgeGroup>(AgeGroups, MemberAgeGroup)